<template>
  <div class="out-warp">
    <div class="s-filter-box no-title">
      <a-space>
        <a-range-picker
          style="width: 340px"
          v-model:value="search.dateRange"
          valueFormat="YYYY-MM-DD"
        />

        <a-button @click="find()">
          <template #icon><search-outlined /></template>
          Find
        </a-button>
      </a-space>
    </div>

    <div
      class="table-box-up"
      :class="{ 'has-footer': isCreated || isSave }"
      ref="tableBoxRef"
    >
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="dataSource"
        :loading="loading"
        :pagination="false"
        :scroll="{ x: '145%', y: tableYHeight }"
        size="small"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleChange"
      >
        <template #headerCell="{ column }">
          <template
            v-if="['date', 'shipStatus', 'sysOrOpt'].includes(column.dataIndex)"
          >
            <div class="has-select">
              <p>{{ column.title }}</p>
              <p>{{ getText(column) }}</p>
            </div>
          </template>
        </template>
      </a-table>
    </div>

    <div class="footer show" v-if="isCreated || isSave" ref="footerRef">
      <a-space>
        <a-button type="primary" v-if="isCreated" @click="created">
          Created
        </a-button>
        <a-button type="primary" v-if="isSave" @click="save">Save</a-button>
        <a-button v-if="isSave" @click="cancel">Cancel</a-button>
      </a-space>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, reactive, computed } from 'vue'
  import { throttle, enStringToHump } from '@/utils'
  import request from '@/utils/request'
  import dayjs from 'dayjs'
  import { useStore } from 'vuex'
  import { SearchOutlined } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'
  const start = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
  const end = dayjs().add(1, 'month').format('YYYY-MM-DD')
  const search = reactive({
    dateRange: [start, end],
  })
  const store = useStore()
  const netGroup = computed(() => store.getters['user/currentNetGroup'])
  const loading = ref(false)
  const masterBody = ref({})
  const find = () => {
    loading.value = true
    const rawData = {
      netGroupId: netGroup.value,
      queryDateColumnName: filteredInfo.value.date[0],
      shipStatus: filteredInfo.value.shipStatus[0],
      dateFrom: dayjs(search.dateRange[0]).valueOf(),
      dateTo: dayjs(search.dateRange[1]).valueOf(),
    }
    request({
      url: '/api/shipment/item/query',
      method: 'post',
      data: rawData,
    })
      .then((res) => {
        masterBody.value = res.body
        dataSource.value = res.body.itemList
        let notJobIdArr = res.body.itemList.filter((item) => !item.jobId)
        const ids = res.body.itemList.map((item) => item.id)

        selectedRowKeys.value = ids

        isCreated.value = notJobIdArr.length > 0
        if (isCreated.value) {
          masterBody.value = { ...res.body, itemList: notJobIdArr }
          dataSource.value = [...notJobIdArr]
        }
        isSave.value = false
      })
      .catch(() => {
        dataSource.value = []
      })
      .finally(() => {
        loading.value = false
      })
  }

  const dataSource = ref([])

  const filteredInfo = ref({
    date: ['plan_pickup_date'],
    shipStatus: [-1],
    sysOrOpt: [''],
  })
  const handleChange = (pagination, filters) => {
    filteredInfo.value = filters
    find()
  }
  const shipStatusList = [
    { text: 'All', value: -1 },
    { text: 'CREATED', value: 0 },
    { text: 'ASSIGNED', value: 1 },
    { text: 'COMPLETED', value: 2 },
  ]
  const columnByList = [
    { text: 'PlanPickUp', value: 'plan_pickup_date' },
    { text: 'RSDS', value: 'rsds_req_pickup_date' },
    { text: 'ActualPickUp', value: 'actual_pickup_date' },
  ]
  const sysoroptList = [
    { text: 'All', value: '' },
    { text: 'System', value: 'System' },
    { text: 'Option', value: 'Option' },
  ]
  const getText = (column) => {
    const f = column.filters.find(
      (item) => item.value === column.filteredValue[0]
    )
    return f ? f.text : ''
  }

  const isSave = ref(false)
  const isCreated = ref(false)
  const selectedRowKeys = ref([])

  const onSelectChange = (changableRowKeys) => {
    selectedRowKeys.value = changableRowKeys
  }
  const created = () => {
    const selectArr = dataSource.value.filter((item) => {
      return !item.jobId && selectedRowKeys.value.includes(item.id)
    })

    isCreated.value = false
    isSave.value = true
    request({
      url: '/api/shipment/item/jobid/create',
      method: 'post',
      data: { ...masterBody.value, itemList: selectArr },
    }).then((res) => {
      masterBody.value = res.body
      dataSource.value = res.body.itemList
      const ids = res.body.itemList.map((item) => item.id)
      selectedRowKeys.value = ids
    })
  }
  const save = () => {
    request({
      url: '/api/shipment/item/jobid/save',
      method: 'post',
      data: masterBody.value,
      nonstandard: true,
    }).then((res) => {
      if (res.errCode === '0000') {
        message.success(res.body).then(() => {
          find()
        })
      } else {
        if (['3001', '3002', '3003'].includes(res.errCode)) {
          message.error(res.errMsg).then(() => {
            find()
          })
        }
      }
    })
  }
  const cancel = () => {
    find()
  }
  const columns = computed(() => {
    const filtered = filteredInfo.value || null

    return [
      {
        title: 'Date',
        dataIndex: 'date',
        width: '10%',
        filters: columnByList,
        filterMultiple: false,
        filteredValue: filtered.date || null,
        fixed: true,
        onFilter: () => {
          return true
        },
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          const field = enStringToHump(filtered.date[0])
          return a.header[field] - b.header[field]
        },
        customRender({ record, column }) {
          const field = enStringToHump(column.filteredValue[0])
          return dayjs(record.header[field]).format('YYYY-MM-DD')
        },
      },
      {
        title: 'Delivery Unit',
        dataIndex: 'deliveryUnit',
        width: '10%',
        customRender({ record }) {
          return record.header.customerPoNo + '_' + record.header.groupNo
        },
      },
      {
        title: 'Model Name',
        dataIndex: 'modelName',
        width: '12%',
        customRender({ record }) {
          return record.job.modelName
        },
      },
      {
        title: 'Fg Name',
        dataIndex: 'fgName',
        width: '8%',
        customRender({ record }) {
          return record.job.fgName
        },
      },
      {
        title: 'Ship Status',
        dataIndex: 'shipStatus',
        width: '9%',
        filters: shipStatusList,
        filterMultiple: false,
        filteredValue: filtered.shipStatus || null,
        customRender({ record }) {
          const f = shipStatusList.find(
            (item) => item.value === record.header.shipStatus
          )
          return f ? f.text : ''
        },
        onFilter: () => {
          return true
        },
      },
      {
        title: 'SysorOpt',
        dataIndex: 'sysOrOpt',
        width: '9%',
        filters: sysoroptList,
        filterMultiple: false,
        filteredValue: filtered.sysOrOpt || null,
        onFilter: (value, record) => {
          if (filtered.sysOrOpt[0] === '') {
            return true
          } else {
            return record.job.sysOrOpt === value
          }
        },
        customRender({ record }) {
          return record.job.sysOrOpt
        },
      },
      {
        title: 'Qty',
        dataIndex: 'qty',
        width: '4%',
      },
      {
        title: 'preDaysof JobId',
        dataIndex: 'predayOfJobId',
        width: '8%',
        customRender({ record }) {
          return record.job.predayOfJobId
        },
      },
      {
        title: 'JobId',
        dataIndex: 'jobId',
        width: '12%',
      },
      {
        title: 'Priority',
        dataIndex: 'priority',
        width: '6%',
        customRender({ text }) {
          return text === 1 ? 'urgent' : ''
        },
      },
      {
        title: 'netGrp',
        dataIndex: 'netGroup',
        width: '6%',
      },
      {
        title: 'Job Status',
        dataIndex: 'jobStatus',
        width: '8%',
      },
      {
        title: 'Prd Planner',
        dataIndex: 'prdPlanner',
        width: '6%',
      },
      {
        title: 'Gap Calculated',
        dataIndex: 'gapCalculated',
        width: '8%',
      },
      {
        title: 'Delivery Item Rem ark',
        dataIndex: 'delilveryItemRemark',
        width: '11%',
      },
      {
        title: 'optionNumber',
        dataIndex: 'delilveryItemRemark',
        width: '8%',
      },
    ]
  })
  // 设置表格高度==============================
  const tableYHeight = ref(300)
  const tableBoxRef = ref(null)
  const footerRef = ref(null)
  const setTableScrollH = () => {
    if (!tableBoxRef.value) return
    const tableHeader = document.querySelector('.ant-table-header')
    const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44

    tableYHeight.value = tableBoxRef.value.clientHeight - tHeadHeight
  }

  onMounted(() => {
    setTimeout(setTableScrollH, 2000)
    window.addEventListener('resize', throttle(setTableScrollH, 500))
    find()
  })
  //end 设置表格高度=============================================
</script>
<style lang="less" scoped>
  @import '@/styles/variables.less';

  .out-warp {
    height: 100%;
  }
  .table-box-up {
    height: calc(100% - 52px);
    &.has-footer {
      height: calc(100% - 52px - 50px);
    }
  }

  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  :deep(.ant-table) {
    .table-striped {
      background: #fcfcfc;
    }
    .error {
      background: #fff0ed;
      td.ant-table-cell-row-hover {
        background: #fff0ed;
      }
    }
    .ant-table-thead > tr > th {
      background: #e9eef5;
      color: #4e6675;
      padding: 5px;
      line-height: 1.5;
    }
    .has-select {
      p {
        padding: 0;
        margin: 0;
        &:first-child {
          border-bottom: 1px solid #c9d5dc;
        }
        &:last-child {
          font-size: 11px;
          font-weight: normal;
        }
      }
    }
  }
  .footer {
    position: absolute;
    height: 50px;
    background: #f5f5f5;
    border-top: 1px solid #ccc;
    color: #333;
    text-align: center;
    left: 0;
    right: 0;
    bottom: -200px;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    &.show {
      bottom: 0;
    }
  }
</style>
